<template>
  <SeoMetaTags />
  <div class="home-page" v-bind:[attributes.itemId]="page.system.id">
    <AnnouncementSlider
      v-if="announcementsSlider.length > 0"
      :announcements="announcementsSlider"
    />
    <HomeHero
      v-if="(page?.elements?.hero?.value?.length ?? 0) > 0 && page?.elements?.hero?.value?.[0]"
      :model="pageStore.getLinkedItem<HomepageHeroModel>(page?.elements?.hero?.value?.[0] ?? '')"
      v-bind:[attributes.elementCodename]="contentTypes.homepage?.elements?.hero?.codename"
    />
    <RichText
      :value="page.elements?.content?.value"
      v-bind:[attributes.elementCodename]="contentTypes.homepage?.elements?.content?.codename"
    />
  </div>
  <SocialSharePreviewBlock
    v-if="(page?.elements?.socialSharePreview?.value?.length ?? 0) > 0 && page?.elements?.socialSharePreview?.value?.[0]"
    :model="
      pageStore.getLinkedItem<SocialSharePreviewModel>(page?.elements?.socialSharePreview?.value?.[0] ?? '')
    "
  />
</template>
<script setup lang="ts">
import {
  type HomepageHeroModel,
  type HomepageModel,
  type AnnouncementBannerModel,
  type SocialSharePreviewModel
} from '~/models'
import { contentTypes } from '~/models'

const attributes = GetKontentAttributes()
const pageStore = usePageStore()

const announcementStore = useAnnouncementStore()
const announcementsSlider = ref<AnnouncementBannerModel[]>([])

await pageStore.fetchHome()

const page = pageStore.page as HomepageModel

onMounted(async () => {
  await announcementStore.fetchData()
  announcementsSlider.value = announcementStore.getAnnouncementsSlider()
})
</script>
